import { Actions } from './articleGestionActions';

/**
 * Etat initial
 */
const initialState = {
    infosFournisseur: {

        isLoading: false
    }
};

/**
 * Reducer pour le domaine "articleGestion"
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        
        // Informations fournisseur de l'article
        case Actions.FETCH_ARTICLE_INFOS_FOURNISSEUR_REQUEST:
            return {
                ...state,
                infosFournisseur: { ...state.infosFournisseur, isLoading: true }
            };
        case Actions.FETCH_ARTICLE_INFOS_FOURNISSEUR_SUCCESS:
            return {
                ...state, 
                infosFournisseur: { ...action.infos, isLoading: false }
            };
        case Actions.FETCH_ARTICLE_INFOS_FOURNISSEUR_FAILURE:
            return {
                ...state,
                infosFournisseur: { error: action.error, isLoading: false }
            };

        default:
    }

    return state;
};

export default reducer;